import styled from "@emotion/styled";

export const NestedItems = styled.ul(() => ({
    listStyle: "none",
    margin: 0,
    padding: 0,
}));
